import type { ThemeName } from "@huub-web/ui";
import type { ThemeSlotMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { HuubScopeVisual } from "../components/theme-slots/huub/HuubScopeVisual";
import { VerenigingEigenHuisStepCard } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisStepCard";

import { LogoHubHeading } from "../components/theme-slots/shared/LogoHubHeading";
import { VerenigingEigenHuisHubHeading } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisHubHeadingContent";
import { VerenigingEigenHuisPageHeading } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisPageHeading";
import { AsrPageHeading } from "../components/theme-slots/asr/AsrPageHeading";
import { AchmeaPageHeading } from "../components/theme-slots/achmea/AchmeaPageHeading";
import { AllianzPageHeading } from "../components/theme-slots/allianz/AllianzPageHeading";
import { EviVanLanschotPageHeading } from "../components/theme-slots/evi-van-lanschot/EviVanLanschotPageHeading";
import { FnvPageHeading } from "../components/theme-slots/fnv/FnvPageHeading";
import { FundaPageHeading } from "../components/theme-slots/funda/FundaPageHeading";
import { NvmPageHeading } from "../components/theme-slots/nvm/NvmPageHeading";
import { AbnamroScopeIcon } from "../components/theme-slots/abnamro/AbnamroScopeIcon";
import { ObvionPageHeading } from "../components/theme-slots/obvion/ObvionPageHeading";
import { RandstadPageHeading } from "../components/theme-slots/randstad/RandstadPageHeading";
import { VistaPageHeading } from "../components/theme-slots/vista/VistaPageHeading";
import { VerenigingEigenHuisAuthWrapper } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisAuthWrapper";
import { VerenigingEigenHuisMaximumMortgageResultBanner } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisMaximumMortgageResultBanner";
import { VerenigingEigenHuisMaximumMortgageResultComparison } from "../components/theme-slots/vereniging-eigen-huis/VerenigingEigenHuisMaximumMortgageResultComparison";

/**
 * Registry that maps each theme to its component slot overrides.
 * Themes not listed here (or with missing keys) fall back to
 * the default rendering in the consuming component.
 */
export const themeSlotRegistry: Partial<Record<ThemeName, ThemeSlotMap>> = {
  asr: {
    hubHeading: LogoHubHeading,
    pageHeading: AsrPageHeading,
  },
  eviVanLanschot: {
    hubHeading: LogoHubHeading,
    pageHeading: EviVanLanschotPageHeading,
  },
  obvion: {
    hubHeading: LogoHubHeading,
    pageHeading: ObvionPageHeading,
  },
  light: {
    scopeVisual: HuubScopeVisual,
  },
  verenigingEigenHuis: {
    authWrapper: VerenigingEigenHuisAuthWrapper,
    hubHeading: VerenigingEigenHuisHubHeading,
    hubStepCard: VerenigingEigenHuisStepCard,
    pageHeading: VerenigingEigenHuisPageHeading,
    maximumMortgageResultBanner: VerenigingEigenHuisMaximumMortgageResultBanner,
    maximumMortgageResultComparison:
      VerenigingEigenHuisMaximumMortgageResultComparison,
  },
  allianz: {
    hubHeading: LogoHubHeading,
    pageHeading: AllianzPageHeading,
  },
  fnv: {
    hubHeading: LogoHubHeading,
    pageHeading: FnvPageHeading,
  },
  randstad: {
    hubHeading: LogoHubHeading,
    pageHeading: RandstadPageHeading,
  },
  vista: {
    hubHeading: LogoHubHeading,
    pageHeading: VistaPageHeading,
  },
  achmea: {
    hubHeading: LogoHubHeading,
    pageHeading: AchmeaPageHeading,
  },
  funda: {
    hubHeading: LogoHubHeading,
    pageHeading: FundaPageHeading,
  },
  nvm: {
    hubHeading: LogoHubHeading,
    pageHeading: NvmPageHeading,
  },
  abnamro: {
    hubHeading: LogoHubHeading,
    scopeVisual: AbnamroScopeIcon,
  },
  domek: {
    hubHeading: LogoHubHeading,
  },
};
